import { render } from "./tenant-create-import.vue?vue&type=template&id=17b4d997"
import script from "./tenant-create-import.vue?vue&type=script&lang=js"
export * from "./tenant-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__